import { useContext } from 'react';
import MinusRed from '../../../../../Assets/StorefrontIcons/MinusRed.svg';
import PlusGreen from '../../../../../Assets/StorefrontIcons/PlusGreen.svg';
import SixDotsBlack from '../../../../../Assets/StorefrontIcons/SixDotsBlack.svg';
import SixDotsGray from '../../../../../Assets/StorefrontIcons/SixDotsGray.svg';
import { getCachedMediaUrl } from '../../../../../lib/utils/utils';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';

function CategoryBox({ category, isSelected }) {
    const {
        categorySectionDesktop,
        setCategorySectionDesktop,
    } = useContext(StorefrontContext);

    function handleAddClick() {
        setCategorySectionDesktop({
            ...categorySectionDesktop,
            categories: [
                ...categorySectionDesktop.categories, category
            ],
        });
    }

    function handleRemoveClick() {
        const filteredCategories = categorySectionDesktop.categories.filter(item => item.id !== category.id);
        setCategorySectionDesktop({
            ...categorySectionDesktop,
            categories: filteredCategories,
        });
    }

    return (
        <div className='px-3 py-4 rounded-[9px] bg-[#F5F5F5F5] border border-[#EAEAEA] flex items-center gap-2'>
            <div className="w-3 h-auto">
                <img src={isSelected ? SixDotsBlack : SixDotsGray} alt="" />
            </div>

            <div className='w-[calc(100%-12px-36px)] flex items-center gap-2'>
                <div className="size-[52px] rounded-full overflow-hidden">
                    <img className='size-full object-cover' src={getCachedMediaUrl(category.categoryImgUrl[0])} alt="" />
                </div>

                <p className='w-[calc(100%-52px)] font-medium line-clamp-1 text-base text-[#121212]'>{category.categoryName}</p>
            </div>

            <div className="size-9 flex items-center justify-center">
                {
                    isSelected ? 
                    <button onClick={handleRemoveClick} className='size-[18px] flex items-center justify-center outline-none'>
                        <img className='size-full' src={MinusRed} alt="" />
                    </button> : 
                    <button onClick={handleAddClick} className='size-[18px] flex items-center justify-center outline-none'>
                        <img className='size-full' src={PlusGreen} alt="" />
                    </button>
                }
            </div>
        </div>
    );
}

export default CategoryBox;
